<style>
@import '../../assets/css/report.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="search" :submit="search">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <b-form-input v-model="ajaxSearch.用户"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                
                <b-card :header="$t($route.name)" style="overflow-x:scroll">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col" v-for="(list,index) in ajaxWallet" :key="index">{{list.name}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="col" v-for="(list,index) in ajaxWallet" :key="index">{{list.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>

                <b-card :header="$t($route.name)" class="mt-3">
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="search()" v-model="ajaxSearch[title.prop]" v-if="title.prop == 'ID' || title.prop == 'User' || title.prop == '用户'"></b-form-input>
                                <label v-else></label>
                            </template>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import {memberWalletAjaxTable,memberWalletSearch} from '@/system/model/report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',ID:'',用户:'',User:''},
            ajaxRow:'',
            ajaxWallet:[],
            pageLimit:10,
            titles:[],     
            walletTitles:[{
                prop: "id",
                label: this.$t('admin.table_id')
            },{
                prop: "name",
                label: this.$t('admin.table_wallet')
            },{
                prop: "value",
                label: this.$t('admin.table_value')
            }]   
        }
    },methods:{
        initialize(){
            var self = this;
            var result = memberWalletAjaxTable();
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.titles = value.data.tab_title;
                    self.ajaxWallet = value.data.wallet_list;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },search(){
            var self = this;
            var result = memberWalletSearch(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.ID,this.ajaxSearch.用户,this.ajaxSearch.User);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.search();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.search();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
